module.exports = __webpack_public_path__ + "static/media/find a provider icon (active).0a2b6aa0.svg";